import './styles.scss';
import { SITE_URL } from '@/constants/constants';

const PhoneInput = () => import('../../components/phone-input/index.vue');

export default {
    name: 'ProfilePage',

    components: {
        'phone-input': PhoneInput
    },

    data() {
        return {
            role: '',
            group: '',

            menu: [
                {
                    detail: false,
                    button: true,
                    text: 'Profile',
                    url: '/account/profile'
                },
                {
                    detail: false,
                    button: true,
                    text: 'Buildings',
                    url: '/account/subscriptions'
                },
                {
                    detail: false,
                    button: true,
                    text: 'Sync',
                    url: '/account/storage-sync'
                },
                {
                    detail: false,
                    button: true,
                    text: 'Privacy Policy',
                    url: `${SITE_URL}/privacy-policy`
                }
            ],

            editing: false,
        }
    },

    methods: {
        toggleEdit() {
            if (this.editing) {
                this.saveChanges();
            }
            this.editing = !this.editing; // Toggle editing state
            if (this.editing) {
                this.$refs.firstNameInput.setFocus();
            }
        },

        async saveChanges() {
            console.log("user details", this.user);
            // Add logic to handle form submission
            if (this.$store.state.online_status) {

                this.loginAlert = await this.$ionic.loadingController.create({
                    spinner: 'lines',
                    animated: true,
                    message: '',
                    translucent: false,
                });

                this.loginAlert.present();

                const userData = {
                    first_name: this.user.first_name,
                    last_name: this.user.last_name,
                    phone: this.user.phone,
                };

                this.$store
                    .dispatch("updateUserData", userData)
                    .then((response) => {
                        this.loginAlert.dismiss();
                        this.$ionic.alertController
                            .create({
                                message: response,
                                buttons: ["OK"],
                            })
                            .then((a) => a.present());
                    })
                    .catch((error) => {
                        this.loginAlert.dismiss();
                        this.$ionic.alertController
                            .create({
                                message: "Unable to update user data.",
                                buttons: ["OK"],
                            })
                            .then((a) => a.present());
                    });
            } else {
                this.$ionic.alertController
                    .create({
                        message: "Please establish and internet connection and try again.",
                        buttons: ["OK"],
                    })
                    .then((a) => a.present());
            }
        },

        confirmDeleteAccount() {
            // Implement logic to confirm deletion
            console.log('Delete account logic here');
            this.$ionic.alertController
                .create({
                    header: 'Confirm Delete',
                    message: 'Are you sure you want to delete your account?',
                    buttons: [
                        {
                            text: 'Cancel',
                            role: 'cancel',
                            cssClass: 'secondary',
                            handler: () => {
                                console.log('Cancel clicked');
                            },
                        },
                        {
                            text: 'Delete',
                            handler: () => {
                                this.deleteAccount();
                            },
                        },
                    ],
                })
                .then((alert) => alert.present());
        },

        async deleteAccount() {

            if (this.$store.state.online_status) {

                this.loginAlert = await this.$ionic.loadingController.create({
                    spinner: 'lines',
                    animated: true,
                    message: '',
                    translucent: false,
                });

                this.loginAlert.present();

                this.$store
                    .dispatch("deleteAccount")
                    .then((response) => {
                        this.loginAlert.dismiss();
                        this.$ionic.alertController
                            .create({
                                message: response,
                                buttons: [
                                    {
                                        text: 'OK',
                                        handler: () => {
                                            this.$store.dispatch('clearData').then(() => {
                                                this.$router.push({ path: '/' });
                                            });
                                        }
                                    }
                                ]
                            })
                            .then((a) => a.present());
                    })
                    .catch((error) => {
                        this.loginAlert.dismiss();
                        this.$ionic.alertController
                            .create({
                                message: error,
                                buttons: ["OK"],
                            })
                            .then((a) => a.present());
                    });
            } else {
                this.$ionic.alertController
                    .create({
                        message: "Please establish and internet connection and try again.",
                        buttons: ["OK"],
                    })
                    .then((a) => a.present());
            }

        },
    },

    computed: {
        user() {
            return this.$store.state.users.user;
        },

        readonly() {
            return !this.editing;
        },
    },

    created() {
        this.$store.commit('setMenuItems', this.menu);
        this.$store.commit('setMenuDetails', { title: 'Account', slug: 'account' });

        this.role = '{{ insert user role }}';
        this.group = '{{ insert user group }}';
    }
};